import React from 'react';
import styled from '@emotion/styled';
import cx from 'classnames';
import { theme } from '@vimily/bonjoro-ui-components';

import QuestionSection from './QuestionSection';
import ResponseSection from './ResponseSection';

const Container = styled.div<{ bgColor: string }>`
  max-width: 818px;
  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 10%);
  background-color: ${(props) => props.bgColor};
`;

export interface QuestionnaireCardProps {
  className?: string;
  desktopView?: boolean;
  bgColor: string;
  children: React.ReactNode;
}

const colors = theme.colors;
export const questionnaireCardsColors = [
  colors.yellow[100],
  colors.red[100],
  colors.purple[100],
  colors.blue[100],
  colors.orange[300],
  colors.turquoise[100],
];

export default function QuestionnaireCard({
  className = 'bg-yellow-100',
  desktopView = false,
  bgColor,
  children,
}: QuestionnaireCardProps) {
  const responsiveClass =
    'min-h-full block flex-col h-full md:min-h-fit md:min-w-[818px] md:flex md:flex-row md:h-fit md:rounded-2xl';
  const desktopOnlyClass =
    'min-h-fit min-w-[818px] flex flex-row h-fit rounded-2xl';

  return (
    <Container
      className={cx(
        'questionnaireCard overflow-auto overflow-x-hidden w-full relative max-h-full',
        className,
        desktopView ? desktopOnlyClass : responsiveClass
      )}
      bgColor={bgColor}
    >
      {children}
    </Container>
  );
}

export { QuestionSection, ResponseSection };
